import { ActionTypes } from '../actions/types';
import {
  ConfigModel,
  configParamsToConfigModel,
} from '../../models/ConfigModel';
import { ConfigParam } from '../../api';

const initialState: ConfigModel[] = [];

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: ConfigParam[] }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.SET_CLIENT_CONFIG: {
      return configParamsToConfigModel(payload);
    }
    default:
      return state;
  }
}
